<template>
    <div>
        <p class="dropdown-item tw-p-3 tw-text-gray-text md:hover:tw-bg-gray-0 tw-rounded tw-cursor-pointer" :class="{'active': selected}">
            <slot></slot>
        </p>
    </div>
</template>

<script>
export default {
	name: 'DropdownMenuItem',

	props: {
		selected: {
			default: false,
		}
	},

	methods: {
		close() {
			if (typeof this.$parent.close === 'function') {
				this.$parent.close();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
    i {
        @apply tw-pr-2;

        &.pr-1 {
            @apply tw-pr-1;
        }
    }

    p {
        &:active {
            background-color: #EFEFEF;
        }

        &.dropdown-item{
            transition: background-color 0.3s ease-out;

            &.active {
                background-color: #EFEFEF;
            }
        }
    }
</style>
